/* Kleine Wrapper um das Meta Pixel (fbq).
   Vermeidet doppelte Feuerung pro Buchungs-/Lead-Vorgang via lokalem Set.
   Nutzt safe try/catch, damit Werbeblocker o. ä. nie die UI crashen. */

const fired = new Set();

const safe = (fn) => {
  try { return fn(); } catch (_) { /* pixel muss nie kritisch sein */ }
};

const call = (event, params = {}, dedupeKey = "") => safe(() => {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  if (dedupeKey) {
    if (fired.has(dedupeKey)) return;
    fired.add(dedupeKey);
  }
  window.fbq("track", event, params);
});

// Lead-Event: Newsletter-, E-Book- und Funnel-Anmeldungen.
export function metaLead({ contentName = "Lead", source = "", value = 0, currency = "EUR", email = "" } = {}) {
  const key = `lead|${source}|${email || contentName}`;
  call("Lead", {
    content_name: contentName, content_category: source,
    value, currency,
  }, key);
}

// Purchase-Event: bezahlte Kurs-/TrackMan-/Gutschein-Buchung.
export function metaPurchase({ value, currency = "EUR", bookingNumber = "", contentName = "", contentType = "product" } = {}) {
  const v = Number(value) || 0;
  const key = `purchase|${bookingNumber || contentName}|${v}`;
  call("Purchase", {
    value: v, currency,
    content_name: contentName,
    content_ids: bookingNumber ? [bookingNumber] : undefined,
    content_type: contentType,
    num_items: 1,
  }, key);
}
